import CrudPage from '@modules/cruds/CrudPage';
import RoleAclForm from './ACLPrivilegeForm';
import * as yup from 'yup';
import { IConfigComponent } from '@ts/ui-models';

const roleAclPageSchema = yup.object().shape({});

const ACLPrivilegePage = props => {
  const defaultValues = {
    //entityId:,
    //securityRoleId: ,
    //actionId: ,
  };

  const config: IConfigComponent = {
    componentId: 'aclPrivileges',
    aclId: 'taAclPrivileges',
    //entity: 'aclPrivilege',
    fetchURL: '/api/aclPrivileges',
    crudURL: '/api/aclPrivilege',
  };

  return (
    <CrudPage
      key={'roleAclPage'}
      configComponent={config}
      form={RoleAclForm}
      defaultValues={defaultValues}
      validationSchema={roleAclPageSchema}
    />
  );
};

export default ACLPrivilegePage;
